const APP_ROUTES = {
  DASHBOARD: "/dashboard",
  CLINIC: "/clinic",
  ADD_CLINIC: "/add",
  STAFF_SEARCH: "/staff-search",
  ADD_STAFF: "/add-staff",
  CLIENT_SEARCH: "/client-search",
  CLINIC_DOMAIN: "/clinic-domain",
  LOGIN: "/login",
  CONFIRM_OTP: "/confirm-otp",
  REGIONS: "/regions",
  ADMIN_USER: "/admin-user",
  ACCESS_LEVEL_SETTINGS: "/roles",
  FILE_UPLOAD: "/fileUpload",
  FILE_DOCUMENT_TEMPLATE: "/document-template",
  ADD_DOCUMENT_TEMPLATE: "/add-document-template",
  DOCUMENT_TEMPLATE_LABEL_LIST: "/document-template-label-list",
  DATA_IMPORT: "/data-import",
  CLINIC_DETAILS: "/clinic-details",
  STAFF_DOCUMENT_TEMPLATE:"/staff-Plan-template",
  ADD_STAFF_DOCUMENT_TEMPLATE: "/add-staff-Plan-template",
  TRAINING_LINKS:"/training-links",
  ADD_TRAINING_LINKS:"/add-training-link",
  EDIT_TRAINING_LINK:"/edit-training-link",
  EOB_IMPORT:"/eob-import",
  LOGS:"/logs",
  ANNOUNCEMENT:"/announcement",
  ADD_ANNOUNCEMENT:"/add-announcement",
  EDIT_ANNOUNCEMENT:"/edit-announcement",
  CLINIC_INFO: "/clinic-info",
  COPY_SERVICES:"/copy-services",
  DOCUMENT_TRANS_COMPILER: "/document-transcompiler",
  SUBPOENA_REQUEST: "/subpoena-request",
  ADD_SUBPOENA_REQUEST: "/subpoena-request/add",
  SMS_TWILIO_LOOKUP: "/sms-twilio-lookup",
  BAA: '/baa',
  ADD_BAA: '/add-baa',
  HISTORY_BAA: '/baa-history',
  AI_DOCUMENT_TEMPLATE: "/ai-document-template",
};

export default APP_ROUTES;
